import React from 'react';
import { CodeEditor } from '@fabric-ui/components';
import { useGetProjectionFieldCompletions } from '@views/Settings/GroupingRules/hooks';
import { editor } from 'monaco-editor';

const DEFAULT_EDITOR_HEIGHT = 40;

const noKeywordsTheme = {
  name: 'avalor-no-keywords-theme',
  light: {
    inherit: true,
    rules: [{ token: 'keyword', foreground: '000000' }],
    colors: {},
  },
  dark: {
    inherit: true,
    rules: [{ token: 'keyword', foreground: 'D4D4D4' }],
    colors: {},
  },
};

const AvSchemaFieldCompletionEditor = ({
  projectionName,
  onChange,
  value,
  height = DEFAULT_EDITOR_HEIGHT,
  label,
  isInteractive = false,
  error,
  disabled,
  isRequired,
}: {
  projectionName: string;
  onChange: (value) => void;
  value: string | undefined;
  height?: number;
  label?: string;
  isInteractive?: boolean;
  error?: string;
  disabled?: boolean;
  isRequired?: boolean;
}) => {
  const onEditorMount = useGetProjectionFieldCompletions({ projectionName, isInteractive });

  const monacoProps: Partial<editor.IStandaloneEditorConstructionOptions> = {
    lineNumbers: 'off',
    lineDecorationsWidth: 'off',
    overviewRulerLanes: 0,
    hideCursorInOverviewRuler: true,
    scrollbar: {
      vertical: 'hidden',
    },
    fixedOverflowWidgets: false,
    overviewRulerBorder: false,
    renderLineHighlight: 'none',
    lineNumbersMinChars: 0,
    glyphMargin: false,
    folding: false,
    wordWrap: height > DEFAULT_EDITOR_HEIGHT ? 'on' : 'off',
  };
  return (
    <CodeEditor
      label={label}
      height={height}
      language="python"
      style={{ p: 1 }}
      onChange={onChange}
      value={value || ''}
      onMount={onEditorMount}
      options={monacoProps}
      customTheme={noKeywordsTheme}
      error={error}
      disabled={disabled}
      isRequired={isRequired}
    />
  );
};

export default AvSchemaFieldCompletionEditor;
